import type { IconType, NavGroup } from '@graftcode/design-system'
import { Icon } from '@graftcode/design-system'

const NAV_ITEM_REGULAR_TO_FILLED: Partial<Record<IconType, IconType>> = {
  [Icon.SettingsRegular]: Icon.SettingsFilled,
  [Icon.OrganizationRegular]: Icon.OrganizationHorizontalFilled,
  [Icon.PeopleRegular]: Icon.PeopleFilled,
  [Icon.AlertRegular]: Icon.AlertFilled,
  [Icon.ListRegular]: Icon.ListFilled,
  [Icon.HistoryRegular]: Icon.HistoryFilled,
  [Icon.PaymentRegular]: Icon.PaymentFilled,
  [Icon.VideoRegular]: Icon.VideoFilled,
}

/** Routes whose sidebar icon swaps between dedicated regular/filled glyphs. */
const ROUTE_ICON_PAIR_BY_URL: Record<string, { regular: IconType; filled: IconType }> = {
  dashboard: { regular: Icon.HomeRegular, filled: Icon.HomeFilled },
  'service-map': { regular: Icon.FlowchartRegular, filled: Icon.FlowchartFilled },
}

function navItemIcon(item: { url: string; icon: IconType }, isActive: boolean): IconType {
  const pair = ROUTE_ICON_PAIR_BY_URL[item.url]
  if (pair) return isActive ? pair.filled : pair.regular
  if (isActive) return NAV_ITEM_REGULAR_TO_FILLED[item.icon] ?? item.icon
  return item.icon
}

export function getPathSegment(pathname: string | null, locale: string): string {
  if (!pathname) return ''
  return pathname.replace(new RegExp(`^/${locale}(/|$)`), '$1').replace(/^\//, '') || ''
}

export function getMenuItemsWithActiveState(
  items: NavGroup[] | undefined,
  pathname: string | null,
  locale: string
): NavGroup[] | undefined {
  if (!items) return items
  const pathSegment = getPathSegment(pathname, locale)
  return items.map((group) => ({
    ...group,
    items: group.items.map((item) => {
      const isActive = !item.disabled && (pathSegment === item.url || (item.url === 'dashboard' && !pathSegment))

      return {
        ...item,
        active: isActive,
        icon: navItemIcon(item, isActive),
      }
    }),
  }))
}
